import { render, staticRenderFns } from "./product_ingredients.vue?vue&type=template&id=58504af0&scoped=true&"
import script from "./product_ingredients.vue?vue&type=script&lang=js&"
export * from "./product_ingredients.vue?vue&type=script&lang=js&"
import style0 from "./product_ingredients.vue?vue&type=style&index=0&id=58504af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58504af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58504af0')) {
      api.createRecord('58504af0', component.options)
    } else {
      api.reload('58504af0', component.options)
    }
    module.hot.accept("./product_ingredients.vue?vue&type=template&id=58504af0&scoped=true&", function () {
      api.rerender('58504af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_ingredients.vue"
export default component.exports